export const DAY = 'day';
export const WEEK = 'week';
